"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _RenderingEngine_defaultLogo, _RenderingEngine_defaultSpinner;
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenderingEngine = void 0;
const THREE = __importStar(require("three"));
const viewer_rendering_engine_animation_engine_1 = require("@shapediver/viewer.rendering-engine.animation-engine");
const viewer_rendering_engine_camera_engine_1 = require("@shapediver/viewer.rendering-engine.camera-engine");
const viewer_rendering_engine_canvas_engine_1 = require("@shapediver/viewer.rendering-engine.canvas-engine");
const viewer_rendering_engine_light_engine_1 = require("@shapediver/viewer.rendering-engine.light-engine");
const viewer_shared_node_tree_1 = require("@shapediver/viewer.shared.node-tree");
const viewer_shared_services_1 = require("@shapediver/viewer.shared.services");
const viewer_shared_types_1 = require("@shapediver/viewer.shared.types");
const gl_matrix_1 = require("gl-matrix");
const EnvironmentMapLoader_1 = require("./loaders/EnvironmentMapLoader");
const GeometryLoader_1 = require("./loaders/GeometryLoader");
const HTMLElementAnchorLoader_1 = require("./loaders/HTMLElementAnchorLoader");
const LightLoader_1 = require("./loaders/LightLoader");
const MaterialLoader_1 = require("./loaders/MaterialLoader");
const ARManager_1 = require("./managers/ARManager");
const CameraManager_1 = require("./managers/CameraManager");
const EnvironmentGeometryManager_1 = require("./managers/EnvironmentGeometryManager");
const FlagManager_1 = require("./managers/FlagManager");
const PostProcessingManager_1 = require("./managers/PostProcessingManager");
const RenderingManager_1 = require("./managers/RenderingManager");
const SceneTracingManager_1 = require("./managers/SceneTracingManager");
const SDTFUtils_1 = require("./managers/sceneTree/SDTFUtils");
const SceneTreeManager_1 = require("./managers/SceneTreeManager");
const SettingsManager_1 = require("./managers/SettingsManager");
const SDColor_1 = require("./objects/SDColor");
const viewport_css_1 = require("./styling/viewport-css");
class RenderingEngine {
    constructor(properties) {
        this._animationEngine = viewer_rendering_engine_animation_engine_1.AnimationEngine.instance;
        this._canvasEngine = viewer_rendering_engine_canvas_engine_1.CanvasEngine.instance;
        this._colorCache = [];
        // utils
        this._converter = viewer_shared_services_1.Converter.instance;
        this._logger = viewer_shared_services_1.Logger.instance;
        this._eventEngine = viewer_shared_services_1.EventEngine.instance;
        this._stateEngine = viewer_shared_services_1.StateEngine.instance;
        this._systemInfo = viewer_shared_services_1.SystemInfo.instance;
        this._tree = viewer_shared_node_tree_1.Tree.instance;
        _RenderingEngine_defaultLogo.set(this, "https://viewer.shapediver.com/v3/graphics/logo_animated_breath.svg");
        _RenderingEngine_defaultSpinner.set(this, "https://viewer.shapediver.com/v3/graphics/spinner_ripple.svg");
        // settings
        this._arRotation = gl_matrix_1.vec3.create();
        this._arScale = gl_matrix_1.vec3.fromValues(1, 1, 1);
        this._arTranslation = gl_matrix_1.vec3.create();
        this._automaticColorAdjustment = true;
        this._automaticResizing = true;
        this._beautyRenderBlendingDuration = 1500;
        this._beautyRenderDelay = 50;
        this._busy = false;
        this._busyModeDisplay = viewer_shared_types_1.BUSY_MODE_DISPLAY.SPINNER;
        this._clearAlpha = 1.0;
        this._clearColor = "#ffffff";
        // viewer global vars
        this._closed = false;
        this._enableAR = true;
        this._environmentMap = "null";
        this._environmentMapAsBackground = false;
        this._environmentMapBlurriness = 0;
        this._environmentMapForUnlitMaterials = false;
        this._environmentMapIntensity = 1;
        this._environmentMapResolution = "1024";
        this._environmentMapRotation = gl_matrix_1.quat.create();
        this._gridVisibility = true;
        this._groundPlaneShadowVisibility = false;
        this._groundPlaneVisibility = true;
        this._lights = true;
        this._maximumRenderingSize = this
            ._systemInfo.isMobile
            ? { width: 1280, height: 720 }
            : { width: 1920, height: 1080 };
        this._pause = false;
        this._shadows = true;
        this._show = false;
        this._showStatistics = false;
        this._softShadows = true;
        this._toneMapping = viewer_shared_types_1.TONE_MAPPING.NONE;
        this._type = viewer_shared_types_1.RENDERER_TYPE.STANDARD;
        this._useLegacyLights = false;
        // THREE object has default Y, we change that (although it doesn't work everywhere)
        THREE.Object3D.DEFAULT_UP = new THREE.Vector3(0, 0, 1);
        THREE.ColorManagement.enabled = false;
        // adapt some of the three.js shaders according to our needs
        (0, MaterialLoader_1.adaptShaders)();
        // add css to the document
        const style = document.createElement("style");
        style.innerHTML = viewport_css_1.css;
        document.head.appendChild(style);
        const prop = Object.assign({}, properties);
        const branding = Object.assign({}, prop.branding);
        // setting some of the provided properties
        this._id = prop.id || viewer_shared_services_1.UuidGenerator.instance.create();
        this._visibilitySessionIds = prop.visibilitySessionIds;
        this._visibility = prop.visibility || viewer_shared_types_1.VISIBILITY_MODE.SESSION;
        this._branding = {
            logo: branding.logo === undefined ? __classPrivateFieldGet(this, _RenderingEngine_defaultLogo, "f") : branding.logo,
            backgroundColor: branding.backgroundColor || "#393a45FF",
            busyModeSpinner: branding.busyModeSpinner === undefined
                ? __classPrivateFieldGet(this, _RenderingEngine_defaultSpinner, "f")
                : branding.busyModeSpinner,
            busyModeDisplay: branding.busyModeDisplay || viewer_shared_types_1.BUSY_MODE_DISPLAY.SPINNER,
            spinnerPositioning: branding.spinnerPositioning || viewer_shared_types_1.SPINNER_POSITIONING.BOTTOM_RIGHT,
        };
        // creation of viewer essentials
        this._canvas = this._canvasEngine.getCanvas(this._canvasEngine.createCanvasObject(prop.canvas));
        // creation of the engines (all singleton engines were created already)
        this._domEventEngine = new viewer_shared_services_1.DomEventEngine(this._canvas.canvasElement);
        this._cameraEngine = new viewer_rendering_engine_camera_engine_1.CameraEngine(this);
        this._lightEngine = new viewer_rendering_engine_light_engine_1.LightEngine(this);
        // creation of the managers (all singleton engines were created already)
        this._cameraManager = new CameraManager_1.CameraManager(this);
        this._environmentGeometryManager = new EnvironmentGeometryManager_1.EnvironmentGeometryManager(this);
        this._sceneTracingManager = new SceneTracingManager_1.SceneTracingManager(this);
        this._sceneTreeManager = new SceneTreeManager_1.SceneTreeManager(this);
        this._renderingManager = new RenderingManager_1.RenderingManager(this);
        this._postProcessingManager = new PostProcessingManager_1.PostProcessingManager(this);
        this._settingsManager = new SettingsManager_1.SettingsManager(this, {
            sessionSettingsMode: prop.sessionSettingsMode || viewer_shared_services_1.SESSION_SETTINGS_MODE.FIRST,
            sessionSettingsId: prop.sessionSettingsId,
        });
        this._arManager = new ARManager_1.ARManager(this);
        this._flagManager = new FlagManager_1.FlagManager(this, {
            flags: prop.flags,
        });
        // loaders
        this._environmentMapLoader = new EnvironmentMapLoader_1.EnvironmentMapLoader(this);
        this._materialLoader = new MaterialLoader_1.MaterialLoader(this);
        this._geometryLoader = new GeometryLoader_1.GeometryLoader(this);
        this._htmlElementAnchorLoader = new HTMLElementAnchorLoader_1.HTMLElementAnchorLoader(this);
        this._lightLoader = new LightLoader_1.LightLoader(this);
        // start the creation and initialization process
        this._renderer = this.renderingManager.createRenderer(this._canvas.canvasElement);
        this._spinnerDivElement = this.renderingManager.addSpinner(this._canvas.canvasElement, this._branding);
        this._logoDivElement = this.renderingManager.addLogo(this._canvas.canvasElement, this._branding);
        // creation of the managers (all singleton engines were created already)
        this._cameraManager.init();
        this._environmentGeometryManager.init();
        this._sceneTracingManager.init();
        this._sceneTreeManager.init();
        this._renderingManager.init();
        this._postProcessingManager.init();
        this._settingsManager.init();
        this._arManager.init();
        // loaders
        this._environmentMapLoader.init();
        this._materialLoader.init();
        this._geometryLoader.init();
        this._htmlElementAnchorLoader.init();
        this._lightLoader.init();
    }
    get arRotation() {
        return this._arRotation;
    }
    set arRotation(value) {
        this._arRotation = value;
    }
    get arScale() {
        return this._arScale;
    }
    set arScale(value) {
        this._arScale = value;
    }
    get arTranslation() {
        return this._arTranslation;
    }
    set arTranslation(value) {
        this._arTranslation = value;
    }
    get automaticColorAdjustment() {
        return this._automaticColorAdjustment;
    }
    set automaticColorAdjustment(value) {
        if (this._automaticColorAdjustment === value)
            return;
        this._automaticColorAdjustment = value;
        this._colorCache.forEach((c) => c.colorCorrection(value));
        this._materialLoader.assignColorCorrection(value);
    }
    get automaticResizing() {
        return this._automaticResizing;
    }
    set automaticResizing(value) {
        this._automaticResizing = value;
    }
    get beautyRenderBlendingDuration() {
        return this._beautyRenderBlendingDuration;
    }
    set beautyRenderBlendingDuration(value) {
        this._beautyRenderBlendingDuration = value;
    }
    get beautyRenderDelay() {
        return this._beautyRenderDelay;
    }
    set beautyRenderDelay(value) {
        this._beautyRenderDelay = value;
    }
    get branding() {
        return this._branding;
    }
    get busy() {
        return this._busy;
    }
    set busy(value) {
        this._busy = value;
    }
    get busyModeDisplay() {
        return this._busyModeDisplay;
    }
    set busyModeDisplay(value) {
        this._busyModeDisplay = value;
    }
    get camera() {
        return this._cameraManager.camera;
    }
    get cameraEngine() {
        return this._cameraEngine;
    }
    get cameraManager() {
        return this._cameraManager;
    }
    get canvas() {
        return this._canvas.canvasElement;
    }
    get clearAlpha() {
        return this._clearAlpha;
    }
    set clearAlpha(value) {
        this._clearAlpha = value;
    }
    get clearColor() {
        return this._clearColor;
    }
    set clearColor(value) {
        this._clearColor = value;
    }
    get closed() {
        return this._closed;
    }
    get colorCache() {
        return this._colorCache;
    }
    get contactShadowBlur() {
        return this._environmentGeometryManager.contactShadow.blur;
    }
    set contactShadowBlur(value) {
        this._environmentGeometryManager.contactShadow.blur = value;
    }
    get contactShadowDarkness() {
        return this._environmentGeometryManager.contactShadow.darkness;
    }
    set contactShadowDarkness(value) {
        this._environmentGeometryManager.contactShadow.darkness = value;
    }
    get contactShadowHeight() {
        return this._environmentGeometryManager.contactShadow.height;
    }
    set contactShadowHeight(value) {
        this._environmentGeometryManager.contactShadow.height = value;
    }
    get contactShadowOpacity() {
        return this._environmentGeometryManager.contactShadow.opacity;
    }
    set contactShadowOpacity(value) {
        this._environmentGeometryManager.contactShadow.opacity = value;
    }
    get contactShadowVisibility() {
        return this._environmentGeometryManager.contactShadow.visible;
    }
    set contactShadowVisibility(value) {
        this._environmentGeometryManager.contactShadow.visible = value;
    }
    get continuousRendering() {
        return this._renderingManager.continuousRendering;
    }
    set continuousRendering(value) {
        this._renderingManager.continuousRendering = value;
    }
    get continuousShadowMapUpdate() {
        return this._renderingManager.continuousShadowMapUpdate;
    }
    set continuousShadowMapUpdate(value) {
        this._renderingManager.continuousShadowMapUpdate = value;
    }
    get defaultLineMaterial() {
        return this.materialLoader.defaultLineMaterialData;
    }
    set defaultLineMaterial(value) {
        this.materialLoader.defaultLineMaterialData = value;
    }
    get defaultMaterial() {
        return this.materialLoader.defaultMaterialData;
    }
    set defaultMaterial(value) {
        this.materialLoader.defaultMaterialData = value;
    }
    get defaultMaterialColor() {
        return this.materialLoader.defaultMaterialData.color;
    }
    set defaultMaterialColor(value) {
        this.materialLoader.defaultMaterialData.color = value;
        this.materialLoader.assignDefaultMaterial();
        this.materialLoader.defaultLineMaterialData.color = value;
        this.materialLoader.assignDefaultLineMaterial();
        this.materialLoader.defaultPointMaterialData.color = value;
        this.materialLoader.assignDefaultPointMaterial();
    }
    get defaultPointMaterial() {
        return this.materialLoader.defaultPointMaterialData;
    }
    set defaultPointMaterial(value) {
        this.materialLoader.defaultPointMaterialData = value;
    }
    get domEventEngine() {
        return this._domEventEngine;
    }
    get enableAR() {
        return this._enableAR;
    }
    set enableAR(value) {
        this._enableAR = value;
    }
    get environmentGeometryManager() {
        return this._environmentGeometryManager;
    }
    get environmentMap() {
        return this._environmentMap;
    }
    set environmentMap(value) {
        const previous = this._environmentMap;
        this._environmentMap = value;
        this._environmentMapLoader.load(this.environmentMap).catch((error) => {
            if (error instanceof viewer_shared_services_1.ShapeDiverViewerEnvironmentMapError) {
                this._logger.error(error.message);
            }
            else {
                this._logger.error(`RenderingEngine.environmentMap: Error while loading environment map ${value}: ${error}`);
            }
            this._environmentMap = previous;
            this._environmentMapLoader.load(this.environmentMap);
        });
    }
    get environmentMapAsBackground() {
        return this._environmentMapAsBackground;
    }
    set environmentMapAsBackground(value) {
        this._environmentMapAsBackground = value;
    }
    get environmentMapBlurriness() {
        return this._environmentMapBlurriness;
    }
    set environmentMapBlurriness(value) {
        this._environmentMapBlurriness = value;
        this._sceneTreeManager.scene.backgroundBlurriness =
            this._environmentMapBlurriness;
    }
    get environmentMapForUnlitMaterials() {
        return this._environmentMapForUnlitMaterials;
    }
    set environmentMapForUnlitMaterials(value) {
        this._environmentMapForUnlitMaterials = value;
        this._materialLoader.assignEnvironmentMapForUnlitMaterials(value);
    }
    get environmentMapIntensity() {
        return this._environmentMapIntensity;
    }
    set environmentMapIntensity(value) {
        this._environmentMapIntensity = value;
        this._sceneTreeManager.scene.backgroundIntensity = value;
        this._materialLoader.assignEnvironmentMapIntensity(value);
    }
    get environmentMapLoader() {
        return this._environmentMapLoader;
    }
    get environmentMapResolution() {
        return this._environmentMapResolution;
    }
    set environmentMapResolution(value) {
        this._environmentMapResolution = value;
        this._environmentMapLoader.load(this.environmentMap);
    }
    get environmentMapRotation() {
        return this._environmentMapRotation;
    }
    set environmentMapRotation(value) {
        this._environmentMapRotation = value;
        this._materialLoader.assignEnvironmentMapRotation(value);
    }
    get geometryLoader() {
        return this._geometryLoader;
    }
    get gridColor() {
        return this._environmentGeometryManager.grid.color;
    }
    set gridColor(value) {
        this._environmentGeometryManager.grid.color = value;
    }
    get gridVisibility() {
        return this._gridVisibility;
    }
    set gridVisibility(value) {
        this._environmentGeometryManager.grid.visible = value;
        this._gridVisibility = value;
    }
    get groundPlaneColor() {
        var _a;
        return (_a = this._environmentGeometryManager.groundPlane) === null || _a === void 0 ? void 0 : _a.color;
    }
    set groundPlaneColor(value) {
        this._environmentGeometryManager.groundPlane.color = value;
    }
    get groundPlaneShadowColor() {
        return this._environmentGeometryManager.groundPlaneShadow.color;
    }
    set groundPlaneShadowColor(value) {
        this._environmentGeometryManager.groundPlaneShadow.color = value;
    }
    get groundPlaneShadowVisibility() {
        return this._groundPlaneShadowVisibility;
    }
    set groundPlaneShadowVisibility(value) {
        this._environmentGeometryManager.groundPlaneShadow.visible = value;
        this._groundPlaneShadowVisibility = value;
    }
    get groundPlaneVisibility() {
        return this._groundPlaneVisibility;
    }
    set groundPlaneVisibility(value) {
        this._environmentGeometryManager.groundPlane.visible = value;
        this._groundPlaneVisibility = value;
    }
    get htmlElementAnchorLoader() {
        return this._htmlElementAnchorLoader;
    }
    get id() {
        return this._id;
    }
    get lightEngine() {
        return this._lightEngine;
    }
    get lightLoader() {
        return this._lightLoader;
    }
    get lightScene() {
        return this.lightEngine.lightScene
            ? this.lightEngine.lightScene.id
            : "";
    }
    get lightSceneId() {
        return this.lightEngine.lightScene
            ? this.lightEngine.lightScene.id
            : "";
    }
    get lights() {
        return this._lights;
    }
    set lights(value) {
        this._lights = value;
    }
    get loadDefaultCameras() {
        return this._cameraEngine.loadDefaultCameras;
    }
    set loadDefaultCameras(value) {
        this._cameraEngine.loadDefaultCameras = value;
    }
    get logoDivElement() {
        return this._logoDivElement;
    }
    get materialLoader() {
        return this._materialLoader;
    }
    get materialOverrideType() {
        return this.materialLoader.materialOverrideType;
    }
    set materialOverrideType(value) {
        this.materialLoader.materialOverrideType = value;
    }
    get maximumRenderingSize() {
        return this._maximumRenderingSize;
    }
    set maximumRenderingSize(value) {
        this._maximumRenderingSize = value;
    }
    get minimalRendering() {
        return this.renderingManager.minimalRendering;
    }
    get outputEncoding() {
        switch (this._renderer.outputColorSpace) {
            case THREE.SRGBColorSpace:
                return viewer_shared_types_1.TEXTURE_ENCODING.SRGB;
            case THREE.LinearSRGBColorSpace:
            default:
                return viewer_shared_types_1.TEXTURE_ENCODING.LINEAR;
        }
    }
    set outputEncoding(value) {
        switch (value) {
            case viewer_shared_types_1.TEXTURE_ENCODING.SRGB:
                this._renderer.outputColorSpace = THREE.SRGBColorSpace;
                break;
            case viewer_shared_types_1.TEXTURE_ENCODING.LINEAR:
            default:
                this._renderer.outputColorSpace = THREE.LinearSRGBColorSpace;
                break;
        }
    }
    get pause() {
        return this._pause;
    }
    set pause(value) {
        this._pause = value;
    }
    get physicallyCorrectLights() {
        return !this._useLegacyLights;
    }
    set physicallyCorrectLights(value) {
        this._useLegacyLights = !value;
    }
    get pointSize() {
        return this.materialLoader.defaultPointMaterialData.size || 1;
    }
    set pointSize(value) {
        this.materialLoader.defaultPointMaterialData.size = value;
        this.materialLoader.assignDefaultPointMaterial();
    }
    get postProcessingManager() {
        return this._postProcessingManager;
    }
    get postRenderingCallback() {
        return this._postRenderingCallback;
    }
    set postRenderingCallback(value) {
        this._postRenderingCallback = value;
    }
    get preRenderingCallback() {
        return this._preRenderingCallback;
    }
    set preRenderingCallback(value) {
        this._preRenderingCallback = value;
    }
    get renderer() {
        return this._renderer;
    }
    get renderingManager() {
        return this._renderingManager;
    }
    get scene() {
        return this._sceneTreeManager.scene;
    }
    get sceneTracingManager() {
        return this._sceneTracingManager;
    }
    get sceneTreeManager() {
        return this._sceneTreeManager;
    }
    get sessionSettingsId() {
        return this._settingsManager.sessionSettingsId;
    }
    get sessionSettingsMode() {
        return this._settingsManager.sessionSettingsMode;
    }
    get settingsEngine() {
        return this._settingsManager.settingsEngine;
    }
    get shadows() {
        return this._shadows;
    }
    set shadows(value) {
        this._shadows = value;
    }
    get show() {
        return this._show;
    }
    set show(value) {
        this._show = value;
    }
    get showStatistics() {
        return this._showStatistics;
    }
    set showStatistics(value) {
        this._showStatistics = value;
    }
    get softShadows() {
        return this._softShadows;
    }
    set softShadows(value) {
        this._softShadows = value;
    }
    get spinnerDivElement() {
        return this._spinnerDivElement;
    }
    get suspendSceneUpdates() {
        return this._sceneTreeManager.suspendSceneUpdates;
    }
    set suspendSceneUpdates(value) {
        this._sceneTreeManager.suspendSceneUpdates = value;
    }
    get textureEncoding() {
        switch (this.materialLoader.textureEncoding) {
            case THREE.SRGBColorSpace:
                return viewer_shared_types_1.TEXTURE_ENCODING.SRGB;
            case THREE.LinearSRGBColorSpace:
            default:
                return viewer_shared_types_1.TEXTURE_ENCODING.LINEAR;
        }
    }
    set textureEncoding(value) {
        switch (value) {
            case viewer_shared_types_1.TEXTURE_ENCODING.SRGB:
                this.environmentMapLoader.textureEncoding =
                    THREE.SRGBColorSpace;
                this.materialLoader.textureEncoding = THREE.SRGBColorSpace;
                break;
            case viewer_shared_types_1.TEXTURE_ENCODING.LINEAR:
            default:
                this.environmentMapLoader.textureEncoding =
                    THREE.LinearSRGBColorSpace;
                this.materialLoader.textureEncoding =
                    THREE.LinearSRGBColorSpace;
        }
    }
    get toneMapping() {
        return this._toneMapping;
    }
    set toneMapping(value) {
        this._toneMapping = value;
        switch (value) {
            case viewer_shared_types_1.TONE_MAPPING.LINEAR:
                this._renderer.toneMapping = THREE.LinearToneMapping;
                break;
            case viewer_shared_types_1.TONE_MAPPING.REINHARD:
                this._renderer.toneMapping = THREE.ReinhardToneMapping;
                break;
            case viewer_shared_types_1.TONE_MAPPING.CINEON:
                this._renderer.toneMapping = THREE.CineonToneMapping;
                break;
            case viewer_shared_types_1.TONE_MAPPING.ACES_FILMIC:
                this._renderer.toneMapping = THREE.ACESFilmicToneMapping;
                break;
            case viewer_shared_types_1.TONE_MAPPING.NONE:
            default:
                this._renderer.toneMapping = THREE.NoToneMapping;
        }
        this.materialLoader.updateMaterials();
        this.postProcessingManager.changeEffectPass();
    }
    get toneMappingExposure() {
        return this._renderer.toneMappingExposure;
    }
    set toneMappingExposure(value) {
        this._renderer.toneMappingExposure = value;
    }
    get type() {
        return this._type;
    }
    set type(value) {
        this._type = value;
    }
    get usingSwiftShader() {
        return this.renderingManager.usingSwiftShader;
    }
    get visibility() {
        return this._visibility;
    }
    get visibilitySessionIds() {
        return this._visibilitySessionIds;
    }
    get visualizeAttributes() {
        return this._visualizeAttributes;
    }
    set visualizeAttributes(value) {
        this._visualizeAttributes = value;
    }
    addFlag(flag, inputToken) {
        return this._flagManager.addFlag(flag, inputToken);
    }
    applySettings(sections = {
        ar: true,
        scene: true,
        camera: true,
        light: true,
        environment: true,
        general: true,
        postprocessing: true,
    }, settingsEngine, updateViewport = true) {
        return __awaiter(this, void 0, void 0, function* () {
            return this._settingsManager.applySettings(sections, settingsEngine, updateViewport);
        });
    }
    assignSettingsEngine(settingsEngine) {
        this._settingsManager.assignSettingsEngine(settingsEngine);
    }
    close() {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            this._closed = true;
            this._lightEngine.close();
            this._cameraEngine.close();
            this._renderer.clear(true, true, true);
            this._renderer.dispose();
            this._domEventEngine.removeAllDomEventListener();
            this._domEventEngine.dispose();
            (_a = this._canvas.canvasElement.parentElement) === null || _a === void 0 ? void 0 : _a.removeChild(this._logoDivElement);
            (_b = this._canvas.canvasElement.parentElement) === null || _b === void 0 ? void 0 : _b.removeChild(this._spinnerDivElement);
            (_c = this._canvas.canvasElement.parentNode) === null || _c === void 0 ? void 0 : _c.removeChild(this._htmlElementAnchorLoader.parentDiv);
            this._canvas.reset();
        });
    }
    continueRendering() {
        this._pause = false;
    }
    convert3Dto2D(p) {
        return this.sceneTracingManager.convert3Dto2D(p);
    }
    createSDTFOverview(node) {
        return (0, SDTFUtils_1.createSDTFOverview)(node);
    }
    createThreeJsColor(color) {
        const sdColor = new SDColor_1.SDColor(this._converter.toThreeJsColorInput(color), color);
        sdColor.colorCorrection(this.automaticColorAdjustment);
        this._colorCache.push(sdColor);
        return sdColor;
    }
    displayErrorMessage(message) {
        for (let i = 0; i < this.logoDivElement.children.length; i++)
            this.logoDivElement.children[i].style.visibility =
                "hidden";
        const d = document.createElement("div");
        d.classList.add("sdv-error-message-container");
        this.logoDivElement.appendChild(d);
        const p = document.createElement("p");
        p.textContent = message;
        p.classList.add("sdv-error-message");
        p.style.color = this.logoDivElement.style.backgroundColor;
        d.appendChild(p);
    }
    evaluateFlagState() {
        this._flagManager.evaluateFlagState();
    }
    getEnvironmentMapImageUrl() {
        return this._environmentMapLoader.getEnvironmentMapImageUrl(this.environmentMap);
    }
    getScreenshot(type, encoderOptions) {
        return this._renderingManager.getScreenshot(type, encoderOptions);
    }
    isMobileDeviceWithoutBrowserARSupport() {
        return this._arManager.isMobileDeviceWithoutBrowserARSupport();
    }
    pauseRendering() {
        this._pause = true;
    }
    pointerEventToRay(event) {
        return this._sceneTracingManager.pointerEventToRay(event);
    }
    raytraceScene(origin, direction, filterCriteria) {
        return this._sceneTracingManager.raytraceScene(origin, direction, filterCriteria);
    }
    removeFlag(token) {
        return this._flagManager.removeFlag(token);
    }
    reset() {
        var _a, _b, _c, _d;
        (_a = this._stateEngine.viewportEngines[this.id]) === null || _a === void 0 ? void 0 : _a.settingsAssigned.reset();
        (_b = this._stateEngine.viewportEngines[this.id]) === null || _b === void 0 ? void 0 : _b.boundingBoxCreated.reset();
        (_c = this._stateEngine.viewportEngines[this.id]) === null || _c === void 0 ? void 0 : _c.environmentMapLoaded.reset();
        (_d = this._stateEngine.viewportEngines[this.id]) === null || _d === void 0 ? void 0 : _d.boundingBoxCreated.then(() => {
            this._environmentGeometryManager.changeSceneExtents(this._sceneTreeManager.boundingBox);
        });
    }
    resize(width, height) {
        this._renderingManager.resize(width, height);
        this._renderingManager.render();
    }
    saveSettings(settingsEngine) {
        this._settingsManager.saveSettings(settingsEngine);
    }
    start() {
        var _a;
        this._renderingManager.start();
        (_a = this._stateEngine.viewportEngines[this.id]) === null || _a === void 0 ? void 0 : _a.boundingBoxCreated.then(() => {
            this._environmentGeometryManager.changeSceneExtents(this._sceneTreeManager.boundingBox);
        });
        if (this._settingsManager.sessionSettingsMode ===
            viewer_shared_services_1.SESSION_SETTINGS_MODE.NONE) {
            this.environmentMap = "photo_studio";
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    update(id) {
        if (this.closed)
            return;
        if (this.sceneTreeManager.suspendSceneUpdates === true)
            return;
        this._sceneTreeManager.updateSceneTree(this._tree.root);
        this._renderingManager.updateShadowMap();
        this._animationEngine.updateAnimationData();
        this._renderingManager.render();
        this._eventEngine.emitEvent(viewer_shared_services_1.EVENTTYPE_VIEWPORT.VIEWPORT_UPDATED, {
            viewportId: this.id,
        });
    }
    updateEnvironmentGeometry() {
        this._environmentGeometryManager.updateEnvironmentGeometryPosition();
    }
    viewInAR(file, options) {
        return this._arManager.viewInAR(file, options);
    }
    viewableInAR() {
        return this._arManager.viewableInAR();
    }
}
exports.RenderingEngine = RenderingEngine;
_RenderingEngine_defaultLogo = new WeakMap(), _RenderingEngine_defaultSpinner = new WeakMap();
//# sourceMappingURL=RenderingEngine.js.map